/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import {
  Form,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Button,
  Panel,
  Grid,
  HelpBlock,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import InlineSelect from 'loracoms/InlineSelect';
import ControlTips from 'loracoms/ControlTips';
import Nvl from 'loracoms/Nvl';
import Toolbar from 'loracoms/Toolbar';
import ShowIf from 'loracoms/ShowIf';
import ErrorSet from 'lorautils/errors/ErrorSet';
import callAPI from '@/api/callAPI';
import DeviceModal from '../DeviceModal';
import DvcssModal from '../DvcssModal';
import DpsModal from '../DpsModal';
import styles from './styles.scss';

const propTypes = {
  appId: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  appState: PropTypes.object.isRequired,
};

class NewDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appState: props.appState,
      dps: [],
      checked: [],
      by: 'single',
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'name')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentWillReceiveProps(nextProps) {
    const { appState } = nextProps;
    this.setState({ appState });
  }

  handleChangeDps(dps, modalType) {
    let dpsArr = _.split(dps, ',');
    dpsArr = _.filter(dpsArr, d => (d !== ''));
    this.setState({ dps: dpsArr, modalType });
  }

  handleAdd() {
    this.setState({ showWarning: false });
    const { appId, pushState } = this.props;
    const { checked, name, by, dps, modalType } = this.state;
    _.remove(dps, d => (d === 'lat' || d === 'lng'));

    let charts = [];
    if (by === 'single') {
      if (modalType === 'single') {
        charts = _.map(dps, item => ({ type: item }));
      } else if (modalType === 'merge') {
        charts = [{ type: dps }];
      }
    } else if (by === 'multiple') {
      charts = _.map(dps, item => ({ type: item }));
      charts = _.concat(charts, [{ type: 'lat' }, { type: 'lng' }]);
    }

    const deveui = _.map(checked, c => c.id);
    const ext = { charts, deveui };

    if (deveui.length === 0 || charts.length === 0) {
      this.setState({ showWarning: true });
      return;
    }
    const param = {
      endpoint: '/lora/dashboards',
      method: 'post',
      body: {
        name,
        type: by.toUpperCase(),
        appeui: appId,
        ext: JSON.stringify(ext),
      },
    };
    callAPI(param)
      .then(() => {
        pushState(`/application/${appId}/dashboard`);
      })
      .catch(() => {});
  }

  handleChangeName(e) {
    const name = _.trim(e.target.value);
    this.setState({ name });
  }

  handleChangeBy(by) {
    this.setState({ by, checked: [] });
  }

  handleChangeDevice(checked) {
    this.setState({ checked });
  }

  renderToolbar() {
    const { pushState, appId } = this.props;
    const { appState } = this.state;
    const { status, data: { name } = {} } = appState;
    const breadcrumb = [
      {
        content: this.intlMsg.globalMsg('application.breadcrumb.application'),
        onClick: () => pushState('/application'),
      },
      {
        content: <Nvl status={status} val={name} />,
        onClick: () => pushState(`/application/${appId}/dashboard`),
      }, {
        content: this.intlMsg.msg('adddashboard.add'),
        active: true,
      }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const {
      checked,
      dps,
      name = '',
      errors,
      by = 'single',
      submitted = false,
      showWarning = false,
      showDeviceModal = false,
      showDpsModal = false,
    } = this.state;

    const height = window.innerHeight - 200;
    const { appId } = this.props;
    const deviceName = _.map(checked, device => device.name).join(', ');

    return (
      <div>
        <Grid fluid>
          {this.renderToolbar()}
          <Panel bsStyle="aisz-white" style={{ height }}>
            <Form horizontal>
              <FormGroup>
                <Col md={2}>
                  <ControlLabel bsClass="aisz-control-label">
                    {this.intlMsg.msg('addmodal.name')}
                  </ControlLabel>
                </Col>
                <Col md={4}>
                  <FormControl
                    value={name}
                    bsClass="aisz-form-control-f"
                    placeholder={this.intlMsg.msg('adddashboard.add.placeholder')}
                    onChange={e => this.handleChangeName(e)}
                  />
                  <ControlTips
                    show={errors.has('name') && submitted}
                    message={this.intlMsg.errorMsg(errors.get('name'))}
                    azStyle="danger"
                    placement="right"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col md={2}>
                  <ControlLabel bsClass="aisz-control-label">
                    {this.intlMsg.msg('adddashboard.add.mode')}
                  </ControlLabel>
                </Col>
                <Col md={4}>
                  <InlineSelect
                    bsStyle="aisz-primary"
                    options={[{
                      label: this.intlMsg.msg('new.singlemode'),
                      value: 'single',
                    }, {
                      label: this.intlMsg.msg('new.mapmode'),
                      value: 'multiple',
                    }]}
                    values={[by]}
                    onChange={selected => this.handleChangeBy(selected[0])}
                  />
                  <HelpBlock styleName="help">
                    <i className="fa fa-info-circle" />&nbsp;
                    {this.intlMsg.msg(`adddashboard.add.${by}`)}
                  </HelpBlock>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col md={2}>
                  <ControlLabel bsClass="aisz-control-label">
                    {this.intlMsg.msg('adddashboard.add.device')}
                  </ControlLabel>
                </Col>
                <Col md={4}>
                  <FormControl
                    value={deviceName}
                    bsClass="aisz-form-control-f"
                    disabled
                    styleName="black"
                  />
                  <ControlTips
                    show={errors.has('name') && submitted}
                    message={this.intlMsg.errorMsg(errors.get('name'))}
                    azStyle="danger"
                    placement="right"
                  />
                </Col>
                <Col md={2}>
                  <Button
                    bsStyle="aisz-success"
                    onClick={() => this.setState({ showDeviceModal: true })}
                  >
                    {this.intlMsg.msg('adddashboard.add.select')}
                  </Button>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col md={2}>
                  <ControlLabel bsClass="aisz-control-label">
                    {this.intlMsg.msg('adddashboard.add.datapoint')}
                  </ControlLabel>
                </Col>
                <Col md={4}>
                  <FormControl
                    value={dps.join(', ')}
                    bsClass="aisz-form-control-f"
                    disabled
                    styleName="black"
                  />
                  <ControlTips
                    show={errors.has('name') && submitted}
                    message={this.intlMsg.errorMsg(errors.get('name'))}
                    azStyle="danger"
                    placement="right"
                  />
                </Col>
                <Col md={2}>
                  <Button
                    bsStyle="aisz-success"
                    onClick={() => this.setState({ showDpsModal: true })}
                  >
                    {this.intlMsg.msg('adddashboard.add.select')}
                  </Button>
                </Col>
              </FormGroup>
              <ShowIf if={showWarning}>
                <FormGroup styleName="red">
                  <Col md={6} mdOffset={3}>
                    <i className="fa fa-exclamation-circle" />&nbsp;
                    {this.intlMsg.msg('add.warning')}
                  </Col>
                </FormGroup>
              </ShowIf>
              <FormGroup>
                <Col mdOffset={2} md={4}>
                  <Button
                    bsStyle="aisz-primary"
                    onClick={() => this.handleAdd()}
                    className={styles.fullWidth}
                  >
                    {this.intlMsg.msg('confirm')}
                  </Button>
                </Col>
              </FormGroup>
            </Form>
          </Panel>
        </Grid>
        {
          by !== 'multiple' &&
          <DeviceModal
            appId={appId}
            showModal={showDeviceModal}
            onChoose={d => this.handleChangeDevice(d)}
            onHide={() => this.setState({ showDeviceModal: false })}
          />
        }
        {
          by === 'multiple' &&
          <DvcssModal
            appId={appId}
            showModal={showDeviceModal}
            onChoose={d => this.handleChangeDevice(d)}
            onHide={() => this.setState({ showDeviceModal: false })}
          />
        }
        <DpsModal
          appId={appId}
          showModal={showDpsModal}
          onHide={() => this.setState({ showDpsModal: false })}
          onConfirm={(ds, modalType) => this.handleChangeDps(ds, modalType)}
        />
      </div>
    );
  }
}

NewDashboard.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  appState: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(NewDashboard,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/NewDashboard/index.jsx